<template>
<div>
    <v-row no-gutters v-if="items">
        <v-col class="ml-4 mt-5 font18 bold headline1">พิเศษสำหรับคุณ</v-col>
    </v-row>
    <v-sheet class="mx-auto" max-width="1600" style="background-color: #f7f7f7">
        <v-slide-group
            active-class="success"
            >
            <v-slide-item v-for="(item,i) in items" :key="i" v-slot="{ active }"  class="groupOffer">
                <v-card
                :color="active ? undefined : 'lighten-1'"
                class="ma-2"
                width="320"
                height="256"
                @click="$router.push(`/reward/detail/${item.rewardId}`)"
                >
                <v-img :src="item.pictureUrl" height="163px" class="link" @click="$router.push(`/reward/detail/${item.rewardId}`)"></v-img>
                <v-row class="font16 bold headline1">
                    <v-col class="pl-6 pt-5 pb-0">{{item.name.substring(0, 35)}}..</v-col>
                </v-row>
                <v-row class="font14 headline1">
                    <v-col class="pl-6 pt-0 pb-0">{{item.subName.substring(0, 35)}}.. </v-col>
                </v-row>
                <v-row class="font14 icon2">
                     <v-card
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                color: #fff;
                background-color: #d82148;
                text-align: center;
              "
              >{{ formatNumber(item.point) }}<img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 19px;
                    margin-left:5px;
                    padding-bottom:2px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                /></v-card
            >
                </v-row>
                <v-row class="fill-height" align="center" justify="center">
                    <v-scale-transition>
                    <v-icon v-if="active" color="white" size="48"></v-icon>
                    </v-scale-transition>
                </v-row>
                </v-card>
            </v-slide-item>
        </v-slide-group>
    </v-sheet>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SpecialOffer',
  data () {
    return {
      items: null,
      member: null,
      profile: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getReward () {
      const result = await this.callBeTaskAPI('get', `/reward/line/get?RECORD_STATUS=N&specialOffer=True&quota=0`)
      if (Array.isArray(result)) {
        this.items = result
      }
    }
  }
}
</script>
<style>
.v-slide-group__wrapper { touch-action: pan-y !important; }
</style>



// WEBPACK FOOTER //
// src/components/SpecialOffer.vue